<template>
<div class="row">
  <div class="col-md-3">
    <div class="card card-refine card-plain card-rose">
      <div class="card-body">
        <input type="search" v-model="filters.search" placeholder="Buscar" class="form-control">
        <br>
        <div class="form-check" v-for="(tag, index) in tags" :key="index">
          <label class="form-check-label">
            <input class="form-check-input" type="checkbox" :value="tag" v-model="filters.tags">
            {{tag}}
            <span class="form-check-sign">
              <span class="check"></span>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-9">
    <loading :loading="isLoading" msg="Carregando ofertas" />
    <div class="text-center category-filter">
      <b-dropdown :text="filters.category || 'Filtrar por categoria'" variant="outline-default" class="m-2">
        <b-dropdown-item @click="filters.category = null">Todas as categorias</b-dropdown-item>
        <b-dropdown-item v-for="(category, index) in categorias_de_produtos" :key="index" @click="filters.category = category">{{category}}</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="row">
      <div class="col-md-4" v-for="(offer, index) in filtered_offers" :key="index">
        <div class="card card-product card-plain no-shadow" data-colored-shadow="false">
          <div class="card-header card-header-image">
            <router-link :to="'/oferta-coletiva/'+offer._id">
              <div class="img-container">
                <product-image :product="offer.product_variation" :product_variation="offer.product_variation" css_class="product-image" />
              </div>
            </router-link>
          </div>
          <div class="card-body">
            <router-link :to="'/oferta/'+offer._id">
              <h4 class="card-title">{{offer.product_variation.name}}</h4>
            </router-link>
          </div>
          <div class="card-footer">
            <div class="price-container">
              <span class="price">{{offer.final_price | moeda}}</span>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <div v-if="filtered_offers && filtered_offers.length == 0" class="text-center">
      <br>
      <br>
      <br>
      <p>Nenhuma oferta encontrada.</p>
    </div>
    <div>
      <br>
      <br>
      <div v-if="!demand_success">
        <div class="text-center" v-if="!show_demand_form">
          <p>Não encontrou o que estava buscando?</p>
          <h4>
            <button @click="showDemandForm" type="button" class="btn btn-primary">Envie sua demanda</button>
          </h4>
        </div>
        <b-form @submit.prevent="createDemand" v-if="!isLoading && show_demand_form">
          <h4 class="text-center">Complete os dados abaixo para enviar sua demanda.</h4>
          <br>
          <div class="row">
            <div class="col-sm-12">
              <b-form-group label="Nome *">
                <b-form-input v-model="form.name" v-validate="'required'" name="name" />
                <field-error :msg="veeErrors" field="name" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Email *">
                <b-form-input v-model="form.email" v-validate="'email|required'" name="email" />
                <field-error :msg="veeErrors" field="email" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Telefone / Whatsapp *">
                <b-form-input v-model="form.phone" v-validate="'required'" name="phone" placeholder="(99) 99999-9999" v-mask="['(##) ####-####', '(##) #####-####']" />
                <field-error :msg="veeErrors" field="phone" />
              </b-form-group>
            </div>
            <div class="col-sm-12">
              <b-form-group label="Qual tipo de produto você busca?">
                <select v-model="form.category" class="form-control">
                  <option value="">{{form.category ? "Todas as categorias" : "Selecione a categoria"}}</option>
                  <option :value="categoria" v-for="(categoria, index) in categorias_de_produtos" :key="index">{{categoria}}</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-sm-12">
              <b-form-group label="Descrição da demanda *">
                <b-form-textarea v-model="form.description" placeholder="Descreva aqui o produto que você quer comprar" v-validate="'required'" name="description" />
                <field-error :msg="veeErrors" field="description" />
              </b-form-group>
            </div>
          </div>
          <form-submit :errors="error" :sending="isSending" label="Enviar demanda" />
        </b-form>
      </div>
      <div v-else class="text-center">
        <h4>Sua demanda foi cadastrada com sucesso!</h4>
        <p>Nossa equipe se mobilizará para atender sua demanda e <br> em breve entrará em contato com você.</p>
        <p>O código da sua demanda é: #{{demand_success}}</p>
        <button @click="clearFilters" type="button" class="btn btn-primary btn-lg">Voltar para a loja</button>
      </div>
      <br>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import slugify from 'slugify'
import Loading from '@/components/Loading'
import ProductImage from '@/components/ProductImage'
import FormSubmit from '@/components/FormSubmit'
import FieldError from '@/components/FieldError'
import categorias_de_produtos from '@/data/categorias-de-produtos.json'

export default {

  name: 'CollectiveShop',

  data() {
    return {
      categorias_de_produtos: categorias_de_produtos,
      filters: {
        tags: [],
        search: '',
        category: ''
      },
      offers: null,
      filtered_offers: null,
      tags: [],
      form: {
        name: "",
        email: "",
        phone: "",
        category: "",
        description: "",
      },
      demand_success: false,
      show_demand_form: false
    }
  },

  created() {
    this.list()
  },

  methods: {
    async list() {
      this.isLoading = true
      axios.get('collective_offers').then(response => {
        this.offers = response.data.map(({offer, ...collectiveOffer}) => {
          return {...offer,...collectiveOffer}
        })
        this.applyFilters()

      }).catch(this.showError)

      axios.get('shop/collective_tags').then(response => {
        this.tags = response.data
      }).catch(this.showError)

    },
    applyFilters() {
      this.filtered_offers = this.offers
      if (this.filters.search) {
        this.filtered_offers = this.filtered_offers.filter(offer => {
          var name = slugify(offer.product_variation.name).toLowerCase()
          var search = slugify(this.filters.search).toLowerCase()
          return name.search(search) >= 0
        })
      }

      if (this.filters.tags && this.filters.tags.length) {
        this.filters.tags.forEach(tag => {
          this.filtered_offers = this.filtered_offers.filter(offer => {
            return offer.product_variation.tags.find(offer_tag => {
              return offer_tag.text == tag
            })
          })
        })
      }


      if (this.filters.category && this.filters.category) {
        this.filtered_offers = this.filtered_offers.filter(offer => {
          if (offer.product_variation.product.categories) {
            return offer.product_variation.product.categories.find(category => {
              return category == this.filters.category
            })
          }
        })
      }

      this.isLoading = false
      this.demand_success = false
    },
    clearFilters() {
      this.filters = {
        search: '',
        tags: []
      }
      location.href = "/"
    },
    showDemandForm() {
      if (this.currentUser) {
        this.form.name = this.currentUser.name,
          this.form.email = this.currentUser.email,
          this.form.phone = this.currentUser.phone
      }
      this.show_demand_form = true
    },
    createDemand() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          axios({
            method: 'POST',
            url: 'shop/demand',
            data: this.form
          }).then(resp => {
            var demand = resp.data
            if (demand && demand._id) {
              this.demand_success = demand.code
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    }
  },
  watch: {
    'filters.search': function() {
      this.applyFilters()
    },
    'filters.category': function() {
      this.applyFilters()
    },
    'filters.tags': function() {
      this.applyFilters()
    }
  },
  components: {
    Loading,
    ProductImage,
    FormSubmit,
    FieldError
  }
};
</script>
<style lang="sass">
  .category-filter
    margin-top: 18px
</style>
